import { css } from 'styled-components';

export const cookieSettingsStyles = css`
  color: inherit;
  border: none;
  padding: 0;
  background: none;
  font-family: inherit;
  font-size: inherit;
  cursor: pointer;
  text-align: left;
`;
